module.exports = __webpack_public_path__ + "img/qihang-erjian.caac71e0.png";